"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StoreContext = exports.SelectionProvider = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
/* eslint-disable */
/* TODO: fix ALL linting errors as some may call out code smells */
const react_1 = __importStar(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const selection_store_1 = require("./selection.store");
const selection_types_1 = require("./selection.types");
const StoreContext = (0, react_1.createContext)();
exports.StoreContext = StoreContext;
/**
 * Selection Provider receives the products array and initializes the selection store for you
 * @param {Object} props
 * @param {import('./selection.types.js').Product[]} props.productsData
 * @param {import('./selection.types.js').AttributeValue} props.pageDefinedAttributes
 * @param {import('./selection.types.js').AttributeValue} props.userDefinedAttributes
 * @param {import('./selection.types.js').AttributeValue} props.productOverrides
 * @param {boolean} props.defaultInStock
 * @param {import('react').ReactNode} props.children
 * @returns {import('react').ReactNode}
 */
const SelectionProvider = ({ productsData, pageDefinedAttributes, userDefinedAttributes, productOverrides, defaultInStock = false, children }) => {
    const { initializeStore } = selection_store_1.selectionStore.getState();
    initializeStore(productsData, pageDefinedAttributes, userDefinedAttributes, productOverrides, defaultInStock);
    return ((0, jsx_runtime_1.jsx)(StoreContext.Provider, { value: selection_store_1.selectionStore, children: children }));
};
exports.SelectionProvider = SelectionProvider;
SelectionProvider.propTypes = {
    productsData: selection_types_1.productsData,
    pageDefinedAttributes: selection_types_1.productAttributes,
    userDefinedAttributes: selection_types_1.productAttributes,
    productOverrides: selection_types_1.productOverrides,
    defaultInStock: prop_types_1.default.bool,
    children: prop_types_1.default.any
};
//# sourceMappingURL=selection.context.js.map